import transactions from './article-transactions'

const modules = {
  transactions
}

const state = {
  lastURL: null,
  articleEdits: {
    uri: '',
    title: '',
    content: '',
    contentSidebar: '',
    tags: [],
    roles: {
      read: [],
      write: []
    }
  },
  currentArticle: {
    uri: '',
    title: '',
    content: '',
    contentSidebar: '',
    tags: [],
    roles: {
      read: [],
      write: []
    }
  },
  articleHistory: [],
  articleDeleted: false,
  articleHierarchy: [],
  searchString: '',
  searchResults: [],
  deletionNote: '',
  deletionChildrenAction: '',
  articleValid: false,
  editIsRestore: false
}

const mutations = {
  setLastURL (state, payload) {
    state.lastURL = payload
  },
  setCurrentArticle (state, payload) {
    state.currentArticle = payload
  },
  setArticleHistory (state, payload) {
    state.articleHistory = payload.history
    state.articleDeleted = payload.history[0].lastAction.type === 'DELETE'
    state.deletionNote = payload.deleted_note
  },
  setArticleHierarchy (state, payload) {
    payload.articles.sort((a, b) => a.uri.split('/').length - b.uri.split('/').length)
    const hierarchy = []
    let id = 1 // reserve id 0 for root (inserted optionally later)
    for (const article of payload.articles) {
      const path = article.uri.split('/')
      let depth = 1
      let hierarchySubset = hierarchy // return to root
      for (const pathSeg of path) {
        if (pathSeg === path.slice(-1)[0]) { // if last path segment in uri, push article
          hierarchySubset.push({
            title: article.title,
            uri: article.uri,
            id: id++,
            depth: depth
          })
          break
        } else { // if not last path, set hierarchySubset to article's parent
          for (const potentialParent of hierarchySubset) {
            const uriEnd = potentialParent.uri.split('/').slice(-1)[0]
            if (uriEnd === pathSeg) {
              if (!('children' in potentialParent)) {
                potentialParent.children = []
              }
              hierarchySubset = potentialParent.children // step into parent's children
              depth++
              break
            }
          }
        }
      }
    }
    // sort alphabetically, with HOME_URI on top
    hierarchy.sort((a, b) => (a.uri === process.env.VUE_APP_HOME_URI ? -1 : a.uri.localeCompare(b)))
    state.articleHierarchy = hierarchy
  },
  removeTag (state, tag) {
    const index = state.articleEdits.tags.indexOf(tag)
    if (index !== -1) state.articleEdits.tags.splice(index, 1)
  },
  addTag (state, tag) {
    state.articleEdits.tags.push(tag)
  },
  addReadRole (state, role) {
    state.articleEdits.roles.read.push(role)
  },
  addWriteRole (state, role) {
    state.articleEdits.roles.write.push(role)
  },
  removeReadRole (state, role) {
    const index = state.articleEdits.roles.read.indexOf(role)
    if (index !== -1) state.articleEdits.roles.read.splice(index, 1)
  },
  removeWriteRole (state, role) {
    const index = state.articleEdits.roles.write.indexOf(role)
    if (index !== -1) state.articleEdits.roles.write.splice(index, 1)
  },
  copyArticleForEdit (state) {
    state.articleEdits.uri = state.currentArticle.uri
    state.articleEdits.title = state.currentArticle.title
    state.articleEdits.content = state.currentArticle.content
    state.articleEdits.contentSidebar = state.currentArticle.contentSidebar
    state.articleEdits.tags = state.currentArticle.tags
    state.articleEdits.roles = state.currentArticle.roles
  },
  resetArticleEdits (state) {
    state.articleEdits = {
      uri: '',
      title: '',
      content: '',
      contentSidebar: '',
      tags: [],
      roles: {
        read: [],
        write: []
      }
    }
  },
  editArticleField (state, payload) {
    state.articleEdits[payload.key] = payload.value
  },
  setSearchString (state, payload) {
    state.searchString = payload
  },
  setSearchResults (state, payload) {
    state.searchResults = payload
  },
  setDeletionExtras (state, payload) {
    state.deletionNote = payload.note
    state.deletionChildrenAction = payload.childrenAction
  },
  setArticleValid (state, payload) {
    state.articleValid = payload
  },
  setEditIsRestore (state, payload) {
    state.editIsRestore = payload
  }
}

export default {
  namespaced: true,
  modules,
  state,
  mutations
}
